import { ApiResponse } from "api/types";
import React from "react";
import Alert from "../Alert";
import { adaptResponseError } from "utils/utils";

const ErrorWrapper = ({ errors }: ApiResponse) => {
  return (
    <div>
      {errors
        ? adaptResponseError(errors).length
        : -1 > 0 &&
          adaptResponseError(errors)?.map((error, idx) => (
            <div style={{ marginBottom: 2 }}>
              <Alert key={idx} message={error.message} />
            </div>
          ))}
    </div>
  );
};

export default ErrorWrapper;
